import rgbHex from 'rgb-hex';
import colors from '../../config/colors.json';
import classNames from 'classnames';
let upgradePBGID = require("../../config/ageUpUpgrades.json")
let allTechs = require("../../config/all-unified-techs.json")

function getDataByPgbid(pgbid) {
    let data = upgradePBGID.find(item => item.pbg_id.includes(pgbid)) || null;
    // need to do this since we are mutating the objecft
    let object = { ...data };
    let extraData = findByPbgidWithKey(pgbid);

    if (object && !object.displayName) {
        object.icon = extraData?.icon
        object.displayName = extraData?.key?.match(/wing-(.*)/)?.[1]?.replace('-', ' ').replace(/\b\w/g, c => c.toUpperCase()) || extraData?.key?.replaceAll('-', ' ').replace(/\b\w/g, c => c.toUpperCase())
    }

    return object;
}

function findByPbgidWithKey(targetId) {
    for (let [key, arr] of Object.entries(allTechs)) {
        let found = arr.find(item => String(item.pbgid) === String(targetId));
        if (found) return { key, ...found };
    }
    return null;
}

export function LiveGameAgeUpAsUpgrade({ pgbid, remainingTime, leftSide, color }) {

    let landmarkData = getDataByPgbid(pgbid);
    let mainColor = rgbHex(colors[color]?.mainColor);

    let progressPercentage = (1 - remainingTime / landmarkData.totalTime) * 100; // Clamp between 0 and 100

    return (
        <div className={classNames(`liveGameAgeUpProgress h-[58px] flex px-2`, leftSide ? ' flex-row' : ' flex-row-reverse')} style={{ background: 'linear-gradient(90deg,rgba(29, 39, 47, 0.0) 0%, rgba(29, 39, 47, 1) 10%, rgba(29, 39, 47, 1) 90%, rgba(29, 39, 47, 0.0) 100%)' }}>
            <img className="mx-[4px] my-auto h-[42px] aspect-auto" src={landmarkData.icon} alt={``} style={{ backgroundColor: 'rgb(29, 39, 47)' }} />
            <div className="mx-1 text-white text-xl italic ">
                <div className="h-5 mt-[2px]">{landmarkData.displayName}</div>
                <div className={classNames(`h-5 flex gap-1 items-center mt-[2px]`, leftSide ? 'flex-row justify-start' : 'flex-row-reverse justify-items-end')}>

                    
                    <div>{remainingTime !== -1 ? `${Math.round(remainingTime)}s` : <span className="text-4xl">∞</span>}</div>
                </div>
                <div className={classNames(`progressBar w-[150px] h-[8px] bg-black outline-[#5E6989] outline-1 outline`, leftSide ? 'float-left' : 'float-right')}>
                    <div className={classNames("h-full overflow-hidden", leftSide ? 'float-left' : 'float-right')} style={{ backgroundColor: `#${mainColor}`, width: `${progressPercentage}%`, transition: 'width 0.5s ease-in-out' }}>
                        <div className='h-full opacity-65 w-[300%] bg-repeat-x ' style={{ backgroundImage: `url('/liveGameIcons/bar_dash.png')`, backgroundSize: 'cover', animation: 'barDash 8s linear infinite' }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}